import React from "react";
import { Route, Routes } from "react-router-dom";

// import Bribes from "../pages/Bribe";
// import Chart from "../pages/Chart";
import CreateLiquidity from "../pages/CreateLiquidity";
import Farms from "../pages/Farms";
import ManageFarms from "../pages/Farms/manage";
import Pools from "../pages/Pools";
import Pair from "../pages/Pools/pair";
import Rewards from "../pages/Rewards";
import Swap from "../pages/Swap";
import Vest from "../pages/Vest";
import CreateVest from "../pages/Vest/create";
import ManageVest from "../pages/Vest/manage";
import Vote from "../pages/Vote";

interface RouterProps {}

const Router: React.FC<RouterProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<Swap />} />
      <Route path="/swap" element={<Swap />} />
      <Route path="/vote" element={<Vote />} />
      <Route path="/pools" element={<Pools />} />
      <Route path="/vest" element={<Vest />} />
      <Route path="/vest/:token_id" element={<ManageVest />} />
      <Route path="/vest/create" element={<CreateVest />} />
      <Route path="/pools/create_liquidity" element={<CreateLiquidity />} />
      <Route path="/farms" element={<Farms />} />
      <Route path="/farms/pair/:x/:y" element={<ManageFarms />} />
      <Route path="/pools/pair/:x/:y" element={<Pair />} />
      <Route path="/rewards" element={<Rewards />} />
      {/* <Route path="/bribes" element={<Bribes />} /> */}
    </Routes>
  );
};

export default Router;
